package macha.sh.kotlin.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import macha.sh.kotlin.CircleButtonVariant
import macha.sh.kotlin.UncoloredButtonVariant

@Composable
fun IconButton(label: String, onClick: () -> Unit, content: @Composable () -> Unit) {
    Button(
        onClick = { onClick() },
        Modifier.setVariable(ButtonVars.FontSize, 1.em),
        variant = CircleButtonVariant.then(UncoloredButtonVariant)
    ) {
        Span(attrs = {
            style {
                property("position", "absolute")
                property("width", "1px")
                property("height", "1px")
                property("padding", "0")
                property("margin", "-1px")
                property("overflow", "hidden")
                property("clip", "rect(0, 0, 0, 0)")
                property("white-space", "nowrap")
                property("border", "0")
            }
        }) {
            Text(label)
        }
        content()
    }
}
